export default __webpack_public_path__ + "static/media/NightSkyProtofoilo.4f1c17f7.jpg";